export default "__VITE_ASSET__CB$lcFCs__"